import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'common/Tooltip';

const DropdownItemButton = ({
  onClick, icon, text, disabled, disabledTooltipText
}) => {
  const buttonContent = () => (
    <Fragment>
      <i className={`fa fa-${icon}`} aria-hidden />
      {` ${text}`}
    </Fragment>
  );

  function renderDisabledItem() {
    // Re-enable pointer events so Tippy picks up hover (Bootstrap's
    // `.dropdown-item.disabled` sets `pointer-events: none`). `not-allowed`
    // preserves the disabled cursor.
    const disabledItem = (
      <span
        className="dropdown-item disabled"
        style={{ cursor: 'not-allowed', pointerEvents: 'auto' }}
      >
        {buttonContent()}
      </span>
    );

    if (disabledTooltipText) {
      return (
        <Tooltip
          content={disabledTooltipText}
          interactive={false}
        >
          {disabledItem}
        </Tooltip>
      );
    }

    return (disabledItem);
  }

  const renderItem = () => (
    <button type="button" className="dropdown-item full-size" onClick={onClick}>
      {buttonContent()}
    </button>
  );

  return (disabled ? renderDisabledItem() : renderItem());
};

DropdownItemButton.propTypes = {
  disabled: PropTypes.bool,
  disabledTooltipText: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

DropdownItemButton.defaultProps = {
  disabled: false,
  disabledTooltipText: null,
};

export default DropdownItemButton;
